<section id="forum" class="forum">
  <div class="forum__left" [class.active]="menu">
    <div class="tags">
      <div class="tags__header" [ngClass]="{ active: openTag }" (click)="openTag = !openTag">Tags <i
          class="fas fa-chevron-down"></i></div>
      <div class="tags__body" [ngClass]="{ active: openTag }">
        <ul>
          <li (click)="handleSelectCategory('')"
            [style.backgroundColor]="forum.categoryId == '' ? 'rgba(var(--primary-r), var(--primary-g), var(--primary-b), 0.2)' : ''">
            All</li>
          <li *ngFor="let item of categories" (click)="handleSelectCategory(item.id)"
            [style.backgroundColor]="forum.categoryId == item.id ? 'rgba(var(--primary-r), var(--primary-g), var(--primary-b), 0.2)' : ''">
            <span>{{ item.name }}</span>
            <span class="number">{{ item.forumCount }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="tags">
      <div class="tags__header" [ngClass]="{ active: openAll }" (click)="openAll = !openAll">{{ activeMainCategory }} <i
          class="fas fa-chevron-down"></i></div>
      <div class="tags__body" [ngClass]="{ active: openAll }">
        <ul>
          <li (click)="mainCategoryChange($event, 'All')"
            [style.backgroundColor]="activeMainCategory == 'All' ? 'rgba(var(--primary-r), var(--primary-g), var(--primary-b), 0.2)' : ''">
            <span>All</span>
          </li>
          <li (click)="mainCategoryChange($event, row)" *ngFor="let row of mainCategories"
            [style.backgroundColor]="activeMainCategory == row ? 'rgba(var(--primary-r), var(--primary-g), var(--primary-b), 0.2)' : ''">
            <span>{{ row }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- center -->
  <div class="forum__center">
    <!-- Latest Threads -->
    <div class="mb-3">
      <div class="card text-white" style="background-color: var(--primary)">
        <div class="card-body py-2 d-flex justify-content-between">
          <p class="text-white" style="font-size: 1.2em">Latest Threads</p>
          <span style="cursor: pointer" (click)="initLatestForums(1)">
            <i class="fa-solid fa-rotate"></i> Refresh
          </span>
        </div>
      </div>
      <ng-container *ngIf="latestForums?.list?.length > 0; else noLatest">
        <div class="forum__center--card" *ngFor="let item of latestForums.list; let index = index">
          <div ngbDropdown class="image">
            <app-forum-profile-popup ngbDropdownMenu [user]="item.user"></app-forum-profile-popup>
            <img loading="lazy" (click)="item.showPopup = !item.showPopup" ngbDropdownToggle
              (clickOutside)="(item.showPopup)"
              src="{{ !item.user?.image ? '../../../../assets/images/new/badge.png' : imgUrl + item.user?.image }}" />
            <div class="image__text">{{ item.user?.userName }}</div>
          </div>
          <div class="body">
            <div class="body__title">
              <div class="d-flex" style="gap: 0.5em">
                <span (click)="openDetailPost(item)" [innerHTML]="item.title"></span>
                <span *ngIf="item.images.length > 0" ngbTooltip>
                  <i class="fa-solid fa-image"></i>
                  <div class="hover-image">
                    <img loading="lazy" *ngFor="let img of item.images" alt="Post Image" [src]="imgUrl + img"
                      (error)="commonService.handleError($event)" />
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="more-details">
            <div class="all">
              <div class="more-details__list">
                <div class="box">
                  {{ item.repliesCount }}
                </div>
                @if(isLogin == 1) {
                <div class="list" aria-hidden="true" id="latest-list-{{ index }}" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false" (click)="handleShowOptionForum(index)">
                  <i class="fa-solid fa-ellipsis-v"></i>
                </div>
                <div class="dropdown-menu" aria-labelledby="latest-list-{{ index }}">
                  <span ngbDropdownItem class="text-nowrap"
                    *ngIf="appUserId == item.createdBy || roleSer?.roles?.permissions['MEMBER_KOPI_TALK']?.includes('EDIT')"
                    (click)="forumFormModal(item)"> <i class="fa-solid fa-pen"></i> Edit </span>
                  <a ngbDropdownItem class="text-nowrap"
                    *ngIf="appUserId == item.createdBy || roleSer?.roles?.permissions['MEMBER_KOPI_TALK']?.includes('DELETE')"
                    href="#" (click)="deletePost($event, item.id)"> <i class="fa-solid fa-trash"></i> Delete </a>
                  <a ngbDropdownItem class="text-nowrap"
                    *ngIf="roleSer?.roles?.permissions['MEMBER_KOPI_TALK']?.includes('EDIT')" href="#"
                    (click)="handlePinForum($event, item)"> <i class="fa-solid fa-thumbtack"></i> {{ item.isPinned ?
                    "Unpin" : "Pin" }} Post </a>
                  <a ngbDropdownItem class="text-nowrap"
                    *ngIf="roleSer?.roles?.permissions['MEMBER_KOPI_TALK']?.includes('EDIT')" href="#"
                    (click)="$event.preventDefault(); handleMuteForum(item)"> <i class="fa-solid fa-comment-slash"></i>
                    {{ item.isMuted ? "Unmute" : "Mute" }} Post </a>
                  <a ngbDropdownItem class="text-nowrap" href="#"
                    (click)="$event.preventDefault(); handleReport(item.id)"> <i class="fa-solid fa-flag"></i>
                    Report </a>
                </div>
                }
              </div>
              <div class="w-100 d-flex justify-content-between pr-2 py-1">
                <div class="more-details__options pr-2 border-0">
                  <div class="item" style="padding-right: 2px;" (click)="likeForum(item.id, item)">
                    <i class="i fa-{{ hasCheckedForum(item.forumLikes) ? 'solid' : 'regular' }} fa-heart"></i>
                    {{ item.forumLikes.length }}
                  </div>
                  <div class="item"><i class="fa-solid fa-eye"></i> {{ item.visitor }}</div>
                  <div class="item"><i class="fa-solid fa-clock" style="padding-left: 2px;"></i> {{
                    item.createdAtText
                    }}</div>
                </div>
                <div class="d-flex gap-1 border-right" style="gap: 8px;">
                  <div class="pinned">
                    <i class="fa-solid fa-thumbtack" *ngIf="item.isPinned"></i>
                  </div>
                  <span class="item" (click)="copyLink('forum', item)">
                    <i class="fa-solid fa-link"></i>
                  </span>
                  <span *ngIf="item.limitLevel > 0" class="item"
                    ngbTooltip="Limit Access For Level {{ item.limitLevel }}">
                    <i class="fa-solid fa-lock"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #noLatest>
        <div class="alert alert-secondary text-center" role="alert"><i class="fa-regular fa-comment-alt"></i>
          No latest threads</div>
      </ng-template>
    </div>
    <!-- *ngIf="forum.categoryId == '' && !forums.categoryLoad" -->
    <ng-container>
      <ng-container *ngFor="let category of mainCategories">
        <div class="mb-3" *ngIf="activeMainCategory == 'All' || activeMainCategory == category">
          <div class="card text-white" style="background-color: var(--primary)">
            <div class="card-body py-2 d-flex justify-content-between">
              <p class="text-white" style="font-size: 1.2em">{{ category }}</p>
              <span *ngIf="activeMainCategory == 'All'" style="cursor: pointer"
                (click)="mainCategoryChange($event, category)"> <i class="fa-solid fa-list"></i> See More</span>
              <span *ngIf="activeMainCategory != 'All'" style="cursor: pointer"
                (click)="mainCategoryChange($event, 'All')"> <i class="fa-solid fa-arrow-left"></i> Back </span>
            </div>
          </div>
          <ng-container *ngIf="isLoading">
            <div class="card mb-3 skeleton-card" *ngFor="let _ of [1, 2, 3]">
              <div class="card-body d-flex py-0" style="gap: 1em">
                <div class="d-flex flex-column py-3">
                  <div class="skeleton-img rounded-circle"></div>
                  <div class="skeleton-icon mt-2"></div>
                  <div class="skeleton-icon"></div>
                </div>
                <div class="flex-grow-1 border-right py-3 px-2">
                  <div class="skeleton-line"></div>
                  <div class="skeleton-line"></div>
                  <div class="skeleton-line"></div>
                </div>
                <div class="d-flex flex-column py-3">
                  <div class="skeleton-box rounded pb-2"></div>
                  <div class="skeleton-line short mt-2"></div>
                  <div class="skeleton-line short"></div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!isLoading">
            <div *ngIf="forums?.list[category]?.length < 1">
              <div class="alert alert-secondary text-center" role="alert"><i class="fa-regular fa-comment-alt"></i>
                There are no discussions posted at this time</div>
            </div>
            <div class="forum__center--card" *ngFor="let item of forums?.list[category]; let index = index">
              <div ngbDropdown class="image">
                <app-forum-profile-popup ngbDropdownMenu [user]="item.user"></app-forum-profile-popup>
                <img loading="lazy" (click)="item.showPopup = !item.showPopup" ngbDropdownToggle
                  (clickOutside)="(item.showPopup)"
                  src="{{ !item.user?.image ? '../../../../assets/images/new/badge.png' : imgUrl + item.user?.image }}" />
                <div class="image__text">{{ item.user?.userName }}</div>
              </div>
              <div class="body">
                <div class="body__title">
                  <div class="d-flex" style="gap: 0.5em">
                    <span (click)="openDetailPost(item)" [innerHTML]="item.title"></span>
                    <span *ngIf="item.images.length > 0" ngbTooltip>
                      <i class="fa-solid fa-image"></i>
                      <div class="hover-image">
                        <img loading="lazy" *ngFor="let img of item.images" alt="Post Image" [src]="imgUrl + img"
                          (error)="commonService.handleError($event)" />
                      </div>
                    </span>
                  </div>
                </div>
              </div>
              <div class="more-details">
                <div class="all">
                  <div class="more-details__list">
                    <div class="box">
                      {{ item.repliesCount }}
                    </div>
                    @if(isLogin == 1) {
                    <div class="list" aria-hidden="true" id="list-{{ index }}" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false" (click)="handleShowOptionForum(index)">
                      <i class="fa-solid fa-ellipsis-v"></i>
                    </div>
                    <div class="dropdown-menu" aria-labelledby="list-{{ index }}">
                      <span ngbDropdownItem class="text-nowrap"
                        *ngIf="appUserId == item.createdBy || roleSer?.roles?.permissions['MEMBER_KOPI_TALK']?.includes('EDIT')"
                        (click)="forumFormModal(item)"> <i class="fa-solid fa-pen"></i> Edit </span>
                      <a ngbDropdownItem class="text-nowrap"
                        *ngIf="appUserId == item.createdBy || roleSer?.roles?.permissions['MEMBER_KOPI_TALK']?.includes('DELETE')"
                        href="#" (click)="deletePost($event, item.id)"> <i class="fa-solid fa-trash"></i> Delete </a>
                      <a ngbDropdownItem class="text-nowrap"
                        *ngIf="roleSer?.roles?.permissions['MEMBER_KOPI_TALK']?.includes('EDIT')" href="#"
                        (click)="handlePinForum($event, item)"> <i class="fa-solid fa-thumbtack"></i> {{ item.isPinned ?
                        "Unpin" : "Pin" }} Post </a>
                      <a ngbDropdownItem class="text-nowrap"
                        *ngIf="roleSer?.roles?.permissions['MEMBER_KOPI_TALK']?.includes('EDIT')" href="#"
                        (click)="$event.preventDefault(); handleMuteForum(item)"> <i
                          class="fa-solid fa-comment-slash"></i> {{ item.isMuted ? "Unmute" : "Mute" }} Post </a>
                      <a ngbDropdownItem class="text-nowrap" href="#"
                        (click)="$event.preventDefault(); handleReport(item.id)"> <i class="fa-solid fa-flag"></i>
                        Report </a>
                    </div>
                    }
                  </div>
                  <div class="w-100 d-flex justify-content-between pr-2 py-1">
                    <div class="more-details__options pr-2 border-0">
                      <div class="item" style="padding-right: 2px;" (click)="likeForum(item.id, item)">
                        <i class="i fa-{{ hasCheckedForum(item.forumLikes) ? 'solid' : 'regular' }} fa-heart"></i>
                        {{ item.forumLikes.length }}
                      </div>
                      <div class="item"><i class="fa-solid fa-eye"></i> {{ item.visitor }}</div>
                      <div class="item"><i class="fa-solid fa-clock" style="padding-left: 2px;"></i> {{
                        item.createdAtText
                        }}</div>
                    </div>
                    <div class="d-flex gap-1 border-right" style="gap: 8px;">
                      <div class="pinned">
                        <i class="fa-solid fa-thumbtack" *ngIf="item.isPinned"></i>
                      </div>
                      <span class="item" (click)="copyLink('forum', item)">
                        <i class="fa-solid fa-link"></i>
                      </span>
                      <span *ngIf="item.limitLevel > 0" class="item"
                        ngbTooltip="Limit Access For Level {{ item.limitLevel }}">
                        <i class="fa-solid fa-lock"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
    <div class="d-flex {{ forums?.categoryLoad ? 'justify-content-between' : 'justify-content-end' }}">
      <!-- <button *ngIf="forums.categoryLoad" (click)="handleSelectCategory()" class="btn rounded-pill bg-purple mb-3"><i class="fa-solid fa-arrow-left"></i> Back</button> -->
      <nav aria-label="..." class="mb-3" *ngIf="forums?.lastPage > 1">
        <ul class="pagination">
          <li class="page-item" [class.disabled]="forums?.currentPage === 1">
            <button class="page-link" (click)="initForums()">First</button>
          </li>
          <ng-container *ngFor="let page of getPages()">
            <li class="page-item" [class.active]="page === forums?.currentPage">
              <button class="page-link" (click)="initForums(page)">
                {{ page }}
              </button>
            </li>
          </ng-container>
          <li class="page-item" [class.disabled]="forums?.currentPage === forums?.lastPage">
            <button class="page-link" (click)="initForums(forums.lastPage)">Last</button>
          </li>
        </ul>
      </nav>
    </div>
    <div>
      <h1 style="font-size: 28px;  text-align: center;" itemprop="headline">KACHIING FORUM</h1>
      <p style="font-size: 16px;  text-align: center;width:80%;margin:auto;" itemprop="description"><i>Join Kachiing
          Forum – Singapore’s local community for honest reviews, service recommendations, and buying advice. Discover
          the best places to eat, repair, shop, and more with real tips from fellow Singaporeans.
        </i></p>
      <div class="forum-intro" style="margin: 2em auto; max-width: 800px; text-align: center;">
        <h2 style="font-size: 1.5em; font-weight: 600; margin-bottom: 0.5em;">
          Welcome to Kachiing Forum - Singapore’s Trusted Consumer Discussion Hub
        </h2>

        <p style="font-size: 1em; color: #555;">
          Need advice before buying or trying a service in Singapore? Kachiing Forum is where locals share honest
          reviews, recommendations, and insider tips. From the best mobile repair shops to hidden gems for car servicing
          and affordable home makeovers, our community helps you make confident choices.
        </p>
        <p style="font-size: 1em; color: #555;">
          Ask, compare, and discover — all in one local forum built for everyday Singaporeans.
        </p>
      </div>
    </div>
  </div>

  <!-- right -->
  <div class="forum__right">
    <div class="card text-white mb-1" style="background-color: var(--primary)">
      <div class="card-body py-2 d-flex justify-content-between">
        <h3 class="text-white" style="font-size: 1.2em"><i class="fa-solid fa-star"></i> Popular Threads</h3>
      </div>
    </div>
    <ng-container *ngIf="isLoading">
      <div class="card mb-3 skeleton-card" *ngFor="let _ of [1, 2, 3]">
        <div class="card-body d-flex py-0" style="gap: 1em">
          <div class="d-flex flex-column py-3">
            <div class="skeleton-img rounded-circle"></div>
            <div class="skeleton-icon mt-2"></div>
            <div class="skeleton-icon"></div>
          </div>
          <div class="flex-grow-1 border-right py-3 px-2">
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
          </div>
          <div class="d-flex flex-column py-3">
            <div class="skeleton-box rounded pb-2"></div>
            <div class="skeleton-line short mt-2"></div>
            <div class="skeleton-line short"></div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!isLoading">
      <div *ngIf="forums?.popular?.length < 1">
        <div class="alert alert-secondary text-center" role="alert"><i class="fa-regular fa-comment-alt"></i> There are
          no discussions posted at this time</div>
      </div>
      <div class="forum__center--card mini-card" *ngFor="let item of forums?.popular; let index = index">
        <div ngbDropdown class="image">
          <app-forum-profile-popup ngbDropdownMenu [user]="item.user"></app-forum-profile-popup>
          <img loading="lazy" (click)="item.showPopup = !item.showPopup" ngbDropdownToggle
            (clickOutside)="(item.showPopup)"
            src="{{ !item.user?.image ? '../../../../assets/images/new/badge.png' : imgUrl + item.user?.image }}" />
          <div class="image__text">{{ item.user?.userName }}</div>
        </div>
        <div class="body">
          <div class="body__title">
            <div class="d-flex gap-2">
              <span (click)="openDetailPost(item)" [innerHTML]="item.title"></span>
              <span *ngIf="item.images.length > 0" ngbTooltip>
                <i class="fa-solid fa-image"></i>
                <div class="hover-image">
                  <img loading="lazy" *ngFor="let img of item.images" alt="Post Image" [src]="imgUrl + img"
                    (error)="commonService.handleError($event)" />
                </div>
              </span>
            </div>
            <span class="item" (click)="copyLink('forum', item)">
              <i class="fa-solid fa-link"></i>
            </span>
          </div>
          <div class="more-details__options">
            <div class="item"><i class="fa-solid fa-eye"></i> {{ item.visitor }}</div>
            <div class="item"><i class="fa-solid fa-clock"></i> {{ item.createdAt }}</div>
            <div class="item" (click)="likeForum(item.id, item)">
              <div class="text">{{ item.forumLikes.length }}</div>
              <i class="i fa-{{ hasCheckedForum(item.forumLikes) ? 'solid' : 'regular' }} fa-heart"></i>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</section>

<app-form-forum #forumForm></app-form-forum>

<app-sign-in #SignIn></app-sign-in>